export default "__VITE_ASSET__BhYQdTEa__"